/**
 * @generated SignedSource<<46e8d7b96d284ac73ab9b81f04349cbf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type UtilizationGrantUpdateInput = {
  id: string;
  permissions: ReadonlyArray<UtilizationGrantPermission>;
};
export type ShareAccessAccountDrawerUpdateMutation$variables = {
  input: UtilizationGrantUpdateInput;
};
export type ShareAccessAccountDrawerUpdateMutation$data = {
  readonly lockUtilizationGrantUpdate: {
    readonly id: string;
    readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
  };
};
export type ShareAccessAccountDrawerUpdateMutation = {
  response: ShareAccessAccountDrawerUpdateMutation$data;
  variables: ShareAccessAccountDrawerUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "lockUtilizationGrantUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareAccessAccountDrawerUpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShareAccessAccountDrawerUpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "55542dadafb883b1acbe9f9956acfb8c",
    "id": null,
    "metadata": {},
    "name": "ShareAccessAccountDrawerUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ShareAccessAccountDrawerUpdateMutation(\n  $input: UtilizationGrantUpdateInput!\n) {\n  lockUtilizationGrantUpdate(input: $input) {\n    id\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "073aa440a17e8bba3cc4cb3257405da4";

export default node;
